// Minimum number of characters a user must type before the dropdown may be
// shown when `showOptionsRestriction` is enabled.
export const MIN_SEARCH_CHARS = 3;

// Delay before the screen-reader status announcement is updated, to avoid
// announcing every keystroke while the user is still typing.
export const SR_ANNOUNCE_DELAY_MS = 700;

// Roles used to mark non-interactive status/alert rows (e.g. "No matching
// services found") within an Autosuggest's options list.
export const STATUS_ROLES = ['status', 'alert'];
